import React from 'react';
import Hero from './components/library/Hero';
import Main from './components/library/Main';

const Library = () => {
  return (
    <div>
        <Hero />
        <Main />
    </div>
  )
}

export default Library;